<template>
	<div class="md-layout-item">
		<form class="modal-content modal-content--in-group">
			<div class="md-layout">
				<div class="md-layout-item">
					<div v-if="!isEditMode" class="text_left light_bg_color margin_top w_100" v-html="$t('debtorManagement.addDebtor.debtorData.hint')"></div>
					<div v-else class="text_left light_bg_color margin_top w_100" v-html="$t('debtorManagement.editDebtor.debtorData.hint')"></div>
         			 <div v-if="debtorDisabled" class="margin_vertical padding_vertical text_left w_100 background_error_color"><span class="font_bold padding_horizontal" v-html="$t('debtorManagement.editDebtor.debtorDisabled.text')"/></div>
         			 <div class="flex margin_top">
						<div class="flex_1 margin_r">
							<CompanySearchSelect
								v-if="!isEditMode"
								label-text="debtorManagement.debtorData.searchDebtor"
								:disabled="readOnly"
								:value="debtorData"
								:search-function="searchDebtor"
								@input="changeDebtor"
								ref="debtorSelectBox"
							></CompanySearchSelect>
							<md-field :class="[{ 'md-error': errors.has('name')}]">
								<label>{{ $t("common.companyName") }}</label>
								<md-input
									v-model="form.name"
									data-vv-name="name"
									v-validate="modelValidations.name"
									required
									:disabled="isDisabled()"
								></md-input>
								<span v-if="errors.has('name')" class="validation-error">{{ errors.first('name') }}</span>
							</md-field>
							<CountrySelect
								v-on:input="onSelectCountry"
								:labelText="$t('common.country')"
								:value="form.country"
								:companyType=enumDef.companyType.DebtorCompany
								:disabled="isDisabled()"
								:required="true"
								data-vv-name="country"
								v-validate="modelValidations.country"
								:error="errors.first('country')"
							></CountrySelect>
							<md-field :class="[{ 'md-error': errors.has('taxNum')}]">
								<label>{{ $t("common.vatId") }}</label>
								<md-input
									v-model="form.taxNum"
									:disabled="isDisabled()"
									:required="modelValidations.taxNum.required"
									data-vv-name="taxNum"
									v-validate="modelValidations.taxNum"
								></md-input>
								<span v-if="errors.has('taxNum')" class="validation-error">{{ errors.first('taxNum') }}</span>
							</md-field>
							<register-select
								:country="form.country"
								v-on:input="onRegisterSelect"
								:labelText="$t('common.registrationAuthority')"
								:value="form.companyRegisterId"
								:disabled="isDisabled()"
								:required="modelValidations.companyRegisterId.required"
								data-vv-name="companyRegisterId"
								v-validate="modelValidations.companyRegisterId"
								:error="errors.first('companyRegisterId')"
								ref="registerSelect"
								:blacklistFunction="(item) => isDisabled() ? null : item.enabled === false"
							></register-select>
							<md-field :class="[{ 'md-error': errors.has('registrationNum')}]" v-if="showRegistrationNumber">
								<label>{{ $t("Completion.Company.RegisterNo") }}</label>
								<md-input
									:disabled="isDisabled()"
									v-model="form.registrationNum"
									data-vv-name="registrationNum"
									v-validate="modelValidations.registrationNum"
									:required="modelValidations.registrationNum.required"
								></md-input>
								<span v-if="errors.has('registrationNum')" class="validation-error">{{ errors.first('registrationNum') }}</span>
							</md-field>
							<legalForm-select
								:country="form.country"
								v-on:input="onLegalSelect"
								:labelText="$t('signUp.componyInfo.legalForm')"
								:disabled="isDisabled()"
								:value="form.legalStructure"
								:required="modelValidations.legalStructure.required"
								data-vv-name="legalStructure"
								v-validate="modelValidations.legalStructure"
								:error="errors.first('legalStructure')"
								:companyType=enumDef.companyType.DebtorCompany
		  						:blacklistFunction="(item) => isDisabled() ? null : item.enabled === false"
							></legalForm-select>
						</div>
						<div class="flex_1">
							<md-field :class="[{ 'md-error': errors.has('address_street') }]">
								<label>{{ $t("Completion.Company.Street") }}</label>
								<md-input
									v-model="form.address_street"
									data-vv-name="address_street"
									:disabled="isDisabled()"
									v-validate="modelValidations.address_street"
									required
								></md-input>
								<span v-if="errors.has('address_street')" class="validation-error">{{ errors.first('address_street') }}</span>
							</md-field>
							<md-field>
								<label>{{ $t("Completion.Company.AddressAddon") }}</label>
								<md-input
									v-model="form.address_addon"
									:disabled="isDisabled()"
								></md-input>
							</md-field>
							<md-field :class="[{ 'md-error': errors.has('address_postcode') }]">
								<label>{{ $t("common.postcode") }}</label>
								<md-input
									v-model="form.address_postcode"
									data-vv-name="address_postcode"
									:disabled="isDisabled()"
									v-validate="modelValidations.address_postcode"
									required
								></md-input>
								<span v-if="errors.has('address_postcode')" class="validation-error">{{ errors.first('address_postcode') }}</span>
							</md-field>

							<md-field :class="[{ 'md-error': errors.has('address_city') }]">
								<label>{{ $t("common.city") }}</label>
								<md-input
									v-model="form.address_city"
									data-vv-name="address_city"
									:disabled="isDisabled()"
									v-validate="modelValidations.address_city"
									required
								></md-input>
								<span v-if="errors.has('address_city')" class="validation-error">{{ errors.first('address_city') }}</span>
							</md-field>
						</div>
					</div>
				</div>
			</div>
		</form>
		<div v-if="isEditMode" class="flex flex_between margin_top">
			<div>
				<md-button v-if="canDeleteRelation" @click="confirmDeleteRelation" class="md-block">
					{{ $t("common.button.delete") }}
				</md-button>
				<md-button v-if="canDisableRelation" @click="confirmDisableRelation" class="md-block">
					{{ $t("common.button.disable") }}
				</md-button>
				<md-button v-if="canEnableRelation && !canReactivateRelation" @click="confirmEnableRelation" class="md-success">
					{{ $t("common.button.enable") }}
				</md-button>
			</div>
			<div>
				<md-button v-if="canSubmitRelationToReview" class="md-primary" @click="submitToReview">
					{{ $t("debtorManagement.addDebtor.submitToReview") }}
				</md-button>
				<md-button v-else-if="canReactivateRelation" @click="confirmEnableRelation" class="md-primary">
					{{ $t("debtorManagement.addDebtor.reactivateAfterExpired") }}
				</md-button>
				<md-button v-else @click="close" class="md-blank">
					{{ $t("common.button.close") }}
				</md-button>
			</div>
		</div>
		<div v-else class="flex flex_between margin_top">
			<md-button class="md-blank" @click="reset">{{ $t("investor.FilterRight.reset") }}</md-button>
			<md-button
				@click="next"
				:class="{ 'md-primary': isFormValid }"
			>{{ $t("common.continue") }}
			</md-button>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
import CountrySelect from "src/components/templates/select/CountrySelect.vue";
import LegalFormSelect from "src/components/templates/select/LegalFormSelect.vue";
import RegisterSelect from "src/components/templates/select/RegisterSelect.vue";
import {validateForm, validateRequiredFields} from "src/validation/validation";
import {enumDef} from "src/common/enumDefs";
import CompanySearchSelect from "src/components/templates/common/CompanySearchSelect";
import {companyApi} from "src/common/api/companyApi";
import {debtorManagementApi} from "@/common/api/debtorManagementApi";

export default {
	props: {
		relationData: { type: Object },
	},
	components: {
		CountrySelect,
		LegalFormSelect,
		RegisterSelect,
		CompanySearchSelect
	},
	data() {
		return {
			modelValidations: {
				name: {
					required: true
				},
				country: {
					required: true,
				},
				registrationNum: {
					required: false
				},
				companyRegisterId: {
					required: false,
				},
				legalStructure: {
					required: false,
				},
				taxNum: {
					required: true,
				},
				address_street: {
					required: true
				},
				address_postcode: {
					required: true
				},
				address_city: {
					required: true
				}
			},
			form: {
				address: {
					addressAddon: "",
					city: "",
					country: "",
					id: "",
					postCode: "",
					street: ""
				},
				address_addon: "",
				address_city: "",
				address_postcode: "",
				address_street: "",
				id: "",
				invitationCode: "",
				name: "",
				taxNum: "",
				registrationNum: "",
				companyRegisterId: "",
				legalStructure: "",
				country: ""
			},
			readOnly: false,
      		debtorDisabled : false,
			showRegistrationNumber: true,
      		enumDef: enumDef
    	};
	},
	mounted() {
		this.loadDebtorData();
	},
	methods: {
		loadDebtorData() {
			if (!this.isEditMode) {
				return;
			}
			companyApi.CompanyInfo(this.relationData.debtorId).then(res => {
				this.changeDebtor(res);
				this.readOnly = true;
			})
		},
		searchDebtor(searchValue) {
			return debtorManagementApi.inspection.debtorSearch({ name: searchValue });
		},
		getData() {
			this.form.address.street = this.form.address_street;
			this.form.address.postCode = this.form.address_postcode;
			this.form.address.city = this.form.address_city;
			this.form.address.addressAddon = this.form.address_addon;
			this.form.address.country = this.form.country;
			this.form.type = 3;
			this.form.ratingStatus = null;
			return this.form;
		},
		isDisabled() {
			let disabled = false;
			if (this.readOnly) {
				disabled = true;
			}

			return disabled;
		},
		reset() {
			this.$refs.debtorSelectBox.resetCompany();
			this.readOnly = false;

			this.validate().catch(() => { /*ignore error*/ });
		},
		changeDebtor(data) {
			this.resetForm();

			if (data) {
				this.readOnly = true;
				this.form = { ...this.form, ...data };
				this.form.address_street = this.form.address.street;
				this.form.address_postcode = this.form.address.postCode;
				this.form.address_city = this.form.address.city;
				this.form.address_addon = this.form.address.addressAddon;
       			this.debtorDisabled = data.disabled !== null ? data.disabled : false;

        		this.$nextTick(() => {
					this.form.legalStructure = data.legalStructure;
					this.form.companyRegisterId = data.companyRegisterId;
          			this.form.registrationNum = data.registrationNum;

					this.validate().catch(() => { /*ignore error*/});
				});
			}
		},
		resetForm() {
			this.debtorDisabled = false;

			for (let key in this.form) {
				if (key === "address") {
					this.form[key] = {
						addressAddon: "",
						city: "",
						country: "",
						id: "",
						postCode: "",
						street: ""
					};
				} else {
					this.form[key] = "";
				}
			}
		},
		onSelectCountry(data) {
			this.form.country = data;
			this.form.legalStructure = "";
			this.form.companyRegisterId = "";
      		this.form.registrationNum = "";
		},
		onRegisterSelect(data) {
			this.form.companyRegisterId = data;
			this.showRegistrationNumber = this.$refs.registerSelect.doesSelectedRequireRegistrationNumber();
		},
		onLegalSelect(author) {
			this.form.legalStructure = author;
		},
		validate() {
			return validateForm(this, this.$validator);
		},
		next() {
			this.validate()
				.then(() => {
					this.form.address.street = this.form.address_street;
					this.form.address.postCode = this.form.address_postcode;
					this.form.address.city = this.form.address_city;
					this.form.address.addressAddon = this.form.address_addon;
					this.form.address.country = this.form.country;
					this.form.type = enumDef.companyType.DebtorCompany;

					this.$emit("next");
				}).catch(this.toast);
		},
		close() {
			this.$emit("close");
		},
		submitToReview() {
			this.$emit("review-relation");
		},
		confirmDisableRelation() {
			let option = {
				title: this.$t("debtorManagement.disableRelation.confirm.title"),
				msg: this.$t("debtorManagement.disableRelation.confirm.text"),
				confirmFun: this.disableRelation
			};
			this.confirmMeg(option, true);
		},
		disableRelation() {
			if (this.relationData.id) {
				debtorManagementApi.operation.disableBusinessRelation(this.relationData.id)
					.then(() => {
						this.close();
						this.$emit("relation-changed");
						this.toastSuccess();
					})
					.catch(this.toast);
			}
		},
		confirmEnableRelation() {
			let option = {
				title: this.canReactivateRelation
					? this.$t("debtorManagement.reactivateRelation.confirm.title")
					: this.$t("debtorManagement.enableRelation.confirm.title"),
				msg: this.canReactivateRelation
					? this.$t("debtorManagement.reactivateRelation.confirm.text")
					: this.$t("debtorManagement.enableRelation.confirm.text"),
				confirmFun: this.enableRelation
			};
			this.confirmMeg(option, true);
		},
		enableRelation() {
			if (this.relationData.id) {
				debtorManagementApi.operation.enableBusinessRelation(this.relationData.id)
					.then(() => {
						this.close();
						this.$emit("relation-changed");
						this.toastSuccess();
					})
					.catch(this.toast);
			}
		},
		confirmDeleteRelation() {
			let option = {
				title: this.$t("debtorManagement.deleteRelation.confirm.title"),
				msg: this.$t("debtorManagement.deleteRelation.confirm.text"),
				confirmFun: this.deleteRelation
			};
			this.confirmMeg(option, true);
		},
		deleteRelation() {
			if (this.relationData.id) {
				debtorManagementApi.operation.deleteBusinessRelation(this.relationData.id)
					.then(() => {
						this.close();
						this.$emit("relation-changed");
						this.toastSuccess();
					})
					.catch(this.toast);
			}
		}
	},
	computed: {
		isFormValid() {
			return validateRequiredFields(this.form, this.modelValidations);
		},
		isEditMode() {
			return this.relationData;
		},
		debtorState() {
			return this.relationData.debtorState;
		},
		canEnableRelation() {
			return this.debtorState === enumDef.debtorState.Deactivated;
		},
		canDisableRelation() {
			return this.debtorState !== enumDef.debtorState.Created && this.debtorState !== enumDef.debtorState.Deactivated;
		},
		canDeleteRelation() {
			return this.debtorState === enumDef.debtorState.Created;
		},
		canSubmitRelationToReview() {
			return this.debtorState === enumDef.debtorState.Created;
		},
		canReactivateRelation() {
			return this.debtorState !== enumDef.debtorState.Created && (moment(this.relationData.expirationTime) < moment());
		},
		...mapGetters({
			debtorData: "debtorData"
		})
	}
};
</script>
